import { supabase } from '../lib/supabase'

// Thin pass-through adapter over the Product Knowledge reader RPCs.
// Every function below maps 1:1 to a single authenticated-only,
// SECURITY DEFINER Postgres function. This file never queries
// catalog/catalog_internal tables directly, and holds no business logic.

export async function getTree() {
  const { data, error } = await supabase.rpc('catalog_get_tree')
  if (error) throw error
  return data || []
}

export async function browseArea(areaKey) {
  const { data, error } = await supabase.rpc('catalog_browse_area', { p_area_key: areaKey })
  if (error) throw error
  return data
}

export async function getUnit(key) {
  const { data, error } = await supabase.rpc('catalog_get_unit', { p_key: key })
  if (error) throw error
  const units = data?.units || []
  return units[0] || null
}

export async function getRelated(key) {
  const { data, error } = await supabase.rpc('catalog_get_related', { p_key: key })
  if (error) throw error
  return data || []
}

export async function getWorkflow(workflowKey) {
  const { data, error } = await supabase.rpc('catalog_get_workflow', { p_workflow_key: workflowKey })
  if (error) throw error
  return data
}

export async function search(query) {
  const q = (query || '').trim()
  if (!q) return []
  const { data, error } = await supabase.rpc('catalog_search', { p_query: q })
  if (error) throw error
  return data || []
}

export async function resolveContext({ route, navKey, tabKey }) {
  const { data, error } = await supabase.rpc('catalog_resolve_context', {
    p_route: route ?? null,
    p_nav_key: navKey ?? null,
    p_tab_key: tabKey ?? null,
  })
  if (error) throw error
  return data
}

// unit: the object returned by getUnit() -- must carry {id, kind, row_version}.
export async function reportGap({ unit, lang, kind, description, referenceText }) {
  const { data, error } = await supabase.rpc('catalog_report_gap', {
    p_unit_key: unit.key,
    p_unit_kind: unit.kind,
    p_unit_id: unit.id,
    p_unit_row_version: unit.row_version,
    p_lang: lang,
    p_kind: kind,
    p_description: description,
    p_reference_text: referenceText ?? null,
  })
  if (error) throw error
  return data
}
